exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.checkbox{padding-bottom:8px}.checkbox,.checkbox .check{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}.checkbox .check{-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;width:1.6rem;height:1.6rem;background-color:#707986;border-radius:.25rem}.checkbox .check.true{background-color:#3fafd7}.checkbox .check i{font-size:1.4rem;line-height:1.4rem}@media (max-width:599px){.checkbox .check{width:1rem;height:1rem}.checkbox .check i{font-size:1rem;line-height:1rem}}.checkbox label{margin:0 0 0 10px}@media (max-width:599px){.checkbox label{font-size:.7rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/pureCheckbox/styles.scss
// module id = 1033
// module chunks = 0